import { render, staticRenderFns } from "./ContainerShuttlePop.vue?vue&type=template&id=62c7473b&scoped=true"
import script from "./ContainerShuttlePop.vue?vue&type=script&lang=js"
export * from "./ContainerShuttlePop.vue?vue&type=script&lang=js"
import style0 from "./ContainerShuttlePop.vue?vue&type=style&index=0&id=62c7473b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c7473b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c7473b')) {
      api.createRecord('62c7473b', component.options)
    } else {
      api.reload('62c7473b', component.options)
    }
    module.hot.accept("./ContainerShuttlePop.vue?vue&type=template&id=62c7473b&scoped=true", function () {
      api.rerender('62c7473b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ContainerShuttlePop.vue"
export default component.exports